import { QueryClient } from '@tanstack/react-query';

/**
 * React Query wraps our Firestore listeners (features #4–#6). Because Firestore
 * onSnapshot pushes updates in realtime, we disable refetch-on-focus/interval
 * and rely on the listeners to keep the cache fresh; staleTime is effectively
 * infinite for listener-backed queries.
 */
export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: Infinity,
      gcTime: 30 * 60 * 1000,
      refetchOnWindowFocus: false,
      refetchOnReconnect: false,
      retry: 1,
    },
  },
});
